var map = {
	"./alloy-wheels.svg": 415,
	"./backup-camera.svg": 149,
	"./bluetooth.svg": 597,
	"./calender.svg": 59,
	"./car.svg": 733,
	"./color.svg": 442,
	"./driver-air-bag.svg": 265,
	"./dummycar.svg": 311,
	"./electric-side-mirror.svg": 780,
	"./engine.svg": 139,
	"./front-ac.svg": 891,
	"./fueltype.svg": 65,
	"./mileage.svg": 527,
	"./passenger-air-bag.svg": 1,
	"./rear-ac.svg": 944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 581;